import router from '@/router'
import useStore from '@/store/main'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ showSpinner: false }) // 进度环显示/隐藏

// 白名单路由
const whiteList = ['/login']

let isRefresh = false //判断是否是刷新页面进入的守卫
const beforeRouter = (to: any, from: any, next: any) => {
  const { permission, user } = useStore()
  const roles = user.roles
  const hasGetRoutes = permission.routes
  // 登录成功，跳转到首页
  if (to.path === '/login') {
    next({ path: '/' })
    NProgress.done()
  } else if (hasGetRoutes.length === 0) {
    // vuex中动态路由是否为空
    permission
      .GetRoutes(roles)
      .then(() => {
        //动态添加路由
        isRefresh = true //圈起来 要考
        next('/')
      })
      .catch(() => {
        NProgress.done()
      })
  } else if (!isRefresh) {
    //页面刷新进入
    permission
      .GetRoutes(roles)
      .then(() => {
        //刷新后vuex中数据会丢失,重新加入
        isRefresh = true //圈起来 重点
        next({ ...to, replace: true }) //hack写法，保证路由已经添加成功
      })
      .catch(() => {
        NProgress.done()
      })
  } else {
    next() //页面加了动态路由了,也不是刷新页面,正常点击按钮触发的操作,直接放行.
  }
}

//判断用户跳转是否合法
router.beforeEach((to: any, from: any, next: any) => {
  const { user } = useStore()
  const hasToken = user.token
  if (hasToken) {
    beforeRouter(to, from, next)
  } else if (whiteList.indexOf(to.path) !== -1) {
    // 未登录可以访问白名单页面(登录页面)
    next()
  } else {
    next(`/login`)
    NProgress.done()
  }
})

router.afterEach((to) => {
  const title = to.meta.title
  if (title) {
    document.title = `${title} | 校体云学生体质健康管理平台` // 设置页面 title
  }
  NProgress.done()
})
